// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HowItsWork_wrapper__1egAo","cards":"HowItsWork_cards__2IZ5q","title":"HowItsWork_title__3v17I"};